import { createAction } from 'app-components/flux/core/actionHelpers';

export const getGoals = createAction(
  'GET_GOALS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getGoalsSuccess = createAction(
  'GET_GOALS_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getGoalsFailure = createAction('GET_GOALS_FAILURE');

export const createGoal = createAction(
  'CREATE_GOAL',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const createGoalSuccess = createAction(
  'CREATE_GOAL_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const createGoalFailure = createAction('CREATE_GOAL_FAILURE');

export const updateGoal = createAction(
  'UPDATE_GOAL',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updateGoalSuccess = createAction(
  'UPDATE_GOAL_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updateGoalFailure = createAction('UPDATE_GOAL_FAILURE');

export const deleteGoal = createAction(
  'DELETE_GOAL',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const deleteGoalSuccess = createAction(
  'DELETE_GOAL_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const deleteGoalFailure = createAction('DELETE_GOAL_FAILURE');

export const updateChangedGoals = createAction('UPDATE_CHANGED_GOALS');
export const performCreateGoal = createAction(
  'PERFORM_CREATE_GOAL',
  (payload) => payload,
  (payload, metadata) => metadata,
);
